const doc = [({"da":({"js":({"buttons":({"table_expand":({"expand":"Udvid"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;